import { render, staticRenderFns } from "./LoadingBanner.vue?vue&type=template&id=05369807&"
import script from "./LoadingBanner.vue?vue&type=script&lang=js&"
export * from "./LoadingBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports